module.exports = __webpack_public_path__ + "img/ch22.7863891c.jpg";